import { createRoute } from "@tanstack/react-router";

import { Customer360View } from "../components/Customer360View";
import { rootRoute } from "./__root";

export const Route = createRoute({
  getParentRoute: () => rootRoute,
  path: "/customers/$contactId",
  component: CustomerDetailScreen,
});

function CustomerDetailScreen() {
  const { contactId } = Route.useParams();
  return <Customer360View contactId={Number.parseInt(contactId, 10)} />;
}
